import { calculatePercentage } from "@/utils/numbers";
import { StatComparison } from "../game/detail/stat-comparison-data";
import { GameAlignmentType, GamePickActivity, LineType } from "common";
import { formatOdd } from "@/utils/odds";
import { useOddsFormat } from "@/utils/providers/odds-format";

export function createPickComparison(game: GamePickActivity): StatComparison[] | undefined {
  const { oddsFormat } = useOddsFormat();

  if (game.odds) {
  return [
    {
      items: [
        {
          label: "Moneyline",
          away: {
            title: `${game.awayMoneylinePicks}`,
            label: `${
              formatOdd(oddsFormat, {
                type: LineType.Moneyline,
                alignment: GameAlignmentType.Away,
                payout: game.odds.awayMoneyline,
                outcome: game.odds.awayMoneylineOutcome,
              })?.payout
            }`,
            value: calculatePercentage(
              game.awayMoneylinePicks,
              game.totalMoneylinePicks
            ),
          },
          home: {
            title: `${game.homeMoneylinePicks}`,
            label: `${
              formatOdd(oddsFormat, {
                type: LineType.Moneyline,
                alignment: GameAlignmentType.Home,
                payout: game.odds.homeMoneyline,
                outcome: game.odds.homeMoneylineOutcome,
              })?.payout
            }`,
            value: calculatePercentage(
              game.homeMoneylinePicks,
              game.totalMoneylinePicks
            ),
          },
        },
        {
          label: "Spread",
          away: {
            title: `${game.awaySpreadPicks}`,
            label: `${
              formatOdd(oddsFormat, {
                type: LineType.Spread,
                alignment: GameAlignmentType.Away,
                value: game.odds.awaySpread,
                payout: game.odds.awaySpreadPayout,
                outcome: game.odds.awaySpreadOutcome,
              })?.value
            }`,
            value: calculatePercentage(game.awaySpreadPicks, game.totalSpreadPicks),
          },
          home: {
            title: `${game.homeSpreadPicks}`,
            label: `${
              formatOdd(oddsFormat, {
                type: LineType.Spread,
                alignment: GameAlignmentType.Home,
                value: game.odds.homeSpread,
                payout: game.odds.homeSpreadPayout,
                outcome: game.odds.homeSpreadOutcome,
              })?.value
            }`,
            value: calculatePercentage(game.homeSpreadPicks, game.totalSpreadPicks),
          },
        },
        
        {
          label: "Total (O/U)",
          away: {
            title: `${game.overPicks}`,
            label: `${
              formatOdd(oddsFormat, {
                type: LineType.Total,
                alignment: GameAlignmentType.Away,
                value: game.odds.overUnder,
                payout: game.odds.overPayout,
                outcome: game.odds.overOutcome,
              })?.value
            }`,
            value: calculatePercentage(
              game.overPicks,
              game.totalOverUnderPicks
            ),
          },
          home: {
            title: `${game.underPicks}`,
            label: `${
              formatOdd(oddsFormat, {
                type: LineType.Total,
                alignment: GameAlignmentType.Home,
                value: game.odds.overUnder,
                payout: game.odds.underPayout,
                outcome: game.odds.underOutcome,
              })?.value
            }`,
            value: calculatePercentage(
              game.underPicks,
              game.totalOverUnderPicks
            ),
          },
        },
      ],
    },
  ];
}
return undefined;
}
